import React, { useEffect, useRef, useState } from "react";
import Footer from "../../components/Footer";

// Short links sent to leads by SMS (/video1, /video2). The videos already carry
// the CPN logo intro and outro, so the page is just the player.
//
// The video starts on its own. Browsers only allow that with sound after the
// visitor has interacted with the site, which someone arriving from an SMS has
// not, so if the unmuted start is refused it plays muted with a tap-for-sound button.
const PromoVideo = ({ src, title }) => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = false;
    setMuted(false);
    video.play().catch(() => {
      video.muted = true;
      setMuted(true);
      video.play().catch(() => {});
    });
  }, [src]);

  const unmute = () => {
    const video = videoRef.current;
    video.muted = false;
    setMuted(false);
    video.play().catch(() => {});
  };

  return (
    <>
      <div className="container mb-5" style={{ minHeight: "60vh" }}>
        <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          <video
            ref={videoRef}
            src={src}
            controls
            playsInline
            preload="auto"
            onVolumeChange={(e) => setMuted(e.currentTarget.muted)}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "#000",
            }}
            title={title}
          />
          {muted && (
            <button
              type="button"
              onClick={unmute}
              className="btn btn-dark"
              style={{ position: "absolute", top: 12, left: 12, opacity: 0.85 }}
            >
              🔊 Tap for sound
            </button>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PromoVideo;
